var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check_circle_black_24dp_1_",
    "data-name": "check_circle_black_24dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17005",
    "data-name": "Path 17005",
    d: "M0,0H20V20H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17006",
    "data-name": "Path 17006",
    d: "M10.745,2a8.745,8.745,0,1,0,8.745,8.745A8.748,8.748,0,0,0,10.745,2Zm0,15.741a7,7,0,1,1,7-7A7.006,7.006,0,0,1,10.745,17.741ZM14.759,6.88,9,12.643,6.731,10.387,5.5,11.62l3.5,3.5,7-7Z",
    transform: "translate(-0.745 -0.745)",
    fill: "#156ae6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.46085db0.svg";
export { ForwardRef as ReactComponent };